import { createContext } from "react";

export const PageContext = createContext<PageContextProps>({});

export type PageContextProps = {
  pageWidth?: number;
  contentWrapper?: HTMLElement | null;
  footerSlot?: HTMLElement | null;
};
